import request from '@/utils/request'

export function gaojingshuliang(query) {
  return request({
    url: '/shuikudaping/getAlarmCount',
    method: 'get',
    params: query
  })
}